/**
 * Created by Dominika.Grabowska on 2016-10-05.
 */
import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/multivalue-manager.hbs';
import BSSSliderComponent from '../../bss-slider-component/js/bss-slider-component.js';
import BSSDropdownComponent from '../../bss-dropdown-component/js/bss-dropdown-component.js';
import BSSLabelComponent from '../../bss-label-component/js/bss-label-component.js';
import BSSRadioButtonComponent from '../../bss-radio-button-component/js/bss-radio-button-component.js';
import BSSRadioTabsComponent from '../../bss-radio-tabs-component/js/bss-radio-tabs-component.js';
import helper from '@main/externals/bss-package-helper/js/helper';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSMultivalueManagerComponent class
 */
var templateObject = {
    defaultTemplate: template,
};
var BSSMultivalueManagerComponent = /** @class */ (function (_super) {
    __extends(BSSMultivalueManagerComponent, _super);
    /**
     * @desc BSSMultivalueManagerComponent constructor - generates all necessary objects and initialize multivalue component
     * @param {Object} _entityTemplate simulator template
     * @param {String} containerSelector - component container selector
     * @param {Object} config - configuration of comonent
     * @param {EventManager} eventManager instance of EventManager
     * @param {Formatter} formatter instance of Formatter
     * @param {Resolution} resolution device Resolution
     * @param {Object} toolbox - provides common libraries: jquery and lodash
     */
    function BSSMultivalueManagerComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        logger.info('MultivalueManagerComponent:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, logger, toolbox);
        _this._componentVersion = '@@name ver. @@version';
        _this.entityReady = false;
        _this._createProperComponent();
        return _this;
    }
    /**
     * @desc merge default component config with calculated config from proxy
     * @private
     * @override
     */
    BSSMultivalueManagerComponent.prototype._prepareData = function () {
        var _a, _b;
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _prepareData');
        /**
         * default value for min steps required for slider
         * @type {Number}
         * @private
         */
        var DEFAULT_MIN_STEP_FOR_SLIDER = 4;
        /**
         * default value for min steps required for dropdown
         * @type {Number}
         * @private
         */
        var DEFAULT_MIN_STEP_FOR_DROPDOWN = 4;
        /**
         * default variables range for possibility to show slider (or only label)
         * @type {Number}
         * @private
         */
        var DEFAULT_MIN_VARIABLE_RANGE = 0;
        /**
         * slider component template
         * @type {String}
         * @private
         */
        if (typeof this.sliderComponentTemplate === 'undefined' &&
            !this._config._isDropdownCreate) {
            this.sliderComponentTemplate = this._config.componentTemplate;
        }
        else if (typeof this.dropdownComponentTemplate === 'undefined') {
            /**
             * dropdown component template
             * @type {String}
             * @private
             */
            this.dropdownComponentTemplate = this._config.componentTemplate;
        }
        this._forceRounded = (_b = (_a = this._config) === null || _a === void 0 ? void 0 : _a.forceRounded) !== null && _b !== void 0 ? _b : false;
        /**
         * step nubmer calculated based on config
         * @type {Null}
         * @private
         */
        this._stepNumber = null;
        /**
         * array of slider values calculated based on config
         * @type {Array}
         * @private
         */
        this._values = [];
        /**
         * array of dropdown options calculated based on config
         * @type {Array}
         * @private
         */
        this._options = [];
        // get slider values & number of steps
        var valuesObj = this._getSliderValuesAndStepNumber();
        this._stepNumber = valuesObj === null || valuesObj === void 0 ? void 0 : valuesObj.stepNumber;
        this._values = valuesObj === null || valuesObj === void 0 ? void 0 : valuesObj.values;
        this._options = valuesObj === null || valuesObj === void 0 ? void 0 : valuesObj.options;
        /**
         * array of all created components
         * @type {Array}
         * @private
         */
        this._createdComponents = [];
        /**
         * if set to true, slider component is created
         * @type {Boolean}
         * @private
         */
        this._isSliderComponent = false;
        /**
         * if set to true, radio-tabs component is created
         * @type {Boolean}
         * @private
         */
        this._isRadioTabsComponent = false;
        /**
         * if set to true, dropdown component is created
         * @type {Boolean}
         * @private
         */
        this._isDropdownComponent = false;
        /**
         * object with config 'variable' value and settings
         * @type {Object}
         * @private
         */
        var startObj = null;
        if (this._config.variable) {
            startObj = this._getValueObject(this._config.variable);
        }
        else {
            startObj = this._getValueObject(this._config.configuration);
        }
        /**
         * config 'variable' product ID from dataResult
         * @type {String}
         * @private
         */
        this._outputProdId = startObj.productId;
        /**
         * config 'variable' name from dataResult
         * @type {String}
         * @private
         */
        this._outputValueName = startObj.value;
        /**
         * config 'variable' formatter from dataResult
         * @type {String}
         * @private
         */
        this._valueFormatter = startObj.formatter;
        /**
         * productIterator
         * @type {number}
         */
        this.productIterator =
            this._config.productId[0] === 'general'
                ? this._config.productId.length - 1
                : 0;
        if (typeof this._sliderLimitVariables) {
            /**
             * slider limit variables based on config - data binding and values
             * @type {Object}
             * @private
             */
            this._sliderLimitVariables = {
                variableMin: null,
                variableMax: null,
                variableStep: null,
                variableList: null,
                numericalObj: {},
            };
        }
        this._prepareLimitObj(this._sliderLimitVariables);
        if (typeof this._mmSettings) {
            /**
             * multivalue manager settings for label, radio tabs and slider component
             * @type {Object}
             * @private
             */
            this._mmSettings = {
                minStepForSlider: DEFAULT_MIN_STEP_FOR_SLIDER,
                minStepForDropdown: DEFAULT_MIN_STEP_FOR_DROPDOWN,
                minVariableRange: DEFAULT_MIN_VARIABLE_RANGE,
                sliderComponentTemplate: this.sliderComponentTemplate,
                dropdownComponentTemplate: this.dropdownComponentTemplate,
            };
        }
        this._prepareMultivalueManagerSettings();
        // reset component template - cannot be the same as for slider!
        this._config.componentTemplate = '';
        /**
         * @desc this flag indicates whether we want to create a dropdown component
         * @type {boolean}
         */
        this._isDropdownCreate = this._config.dropdownCreate
            ? this._config.dropdownCreate
            : false;
    };
    /**
     * @desc prepare object with config settings for multivalue manager
     * @private
     */
    BSSMultivalueManagerComponent.prototype._prepareMultivalueManagerSettings = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _prepareMultivalueManagerSettings');
        if (typeof this._config.multivalueManagerSettings !== 'undefined') {
            for (var item in this._mmSettings) {
                if (typeof this._config.multivalueManagerSettings[item] !== 'undefined') {
                    if (item === 'minStepForSlider' || item === 'minVariableRange') {
                        this._mmSettings[item] = parseInt(this._config.multivalueManagerSettings[item]);
                    }
                    else {
                        this._mmSettings[item] =
                            this._config.multivalueManagerSettings[item];
                    }
                }
            }
        }
    };
    /**
     * @desc create proper component based on config and calculations, possible components: label, radio tabs, slider
     * @private
     */
    BSSMultivalueManagerComponent.prototype._createProperComponent = function () {
        var _a;
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _createProperComponent');
        if ((_a = this._config) === null || _a === void 0 ? void 0 : _a.optional) {
            return;
        }
        // *** ERROR ***
        if (this._stepNumber === null || this._stepNumber === 0) {
            this.setErrorObject({
                errorMsg: 'config -> cannot create slider due to incorrect configuration',
                errorSeverity: 'critical',
            });
            return;
        }
        // *** CREATE LABEL ***
        else if (this._stepNumber === 1) {
            var multivalueLabelConfig = this._toolbox.$.extend(true, {}, this._config.multivalueManagerSettings.labelConfig);
            var labelComp = void 0;
            multivalueLabelConfig.updateSubscriptionOff = true; // prevent update event subscription
            multivalueLabelConfig.componentId =
                this._config.componentId + '_multivalueLabel';
            multivalueLabelConfig.productId = this._config.productId;
            multivalueLabelConfig.texts = this._config.texts;
            multivalueLabelConfig.resultData = this._config.resultData;
            multivalueLabelConfig.componentType = 'LabelComponent';
            if (this._isDropdownCreate && this._options) {
                if (this._valueFormatter) {
                    multivalueLabelConfig.value = this._formatter.getFormattedValue(this._options[0], this._valueFormatter); // always set value fro values, not from config.variable (because may be different)
                }
                else {
                    multivalueLabelConfig.value = this._options[0];
                }
            }
            else if (this._valueFormatter) {
                multivalueLabelConfig.value = this._formatter.getFormattedValue(this._values[0], this._valueFormatter); // always set value fro values, not from config.variable (because may be different)
            }
            else {
                multivalueLabelConfig.value = this._values[0];
            }
            multivalueLabelConfig.tagEvent =
                this._config.multivalueManagerSettings.labelTagEvent;
            labelComp = new BSSLabelComponent(this._entityTemplate, '#' + this._config.componentId, multivalueLabelConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
            this._createdComponents.push(labelComp);
            // save reference to label value
            this.$labelComponentValue = this._componentTemplate.find('#' + multivalueLabelConfig.componentId + ' .bss-label_value');
        }
        // *** CREATE LABEL ***
        else if (this._mmSettings.minVariableRange !== 0 &&
            this._values[this._values.length - 1] - this._values[0] <
                this._mmSettings.minVariableRange) {
            var multivalueLabelConfig = this._toolbox.$.extend(true, {}, this._config.multivalueManagerSettings.labelConfig);
            var labelComp = void 0;
            var value = +this._getValue(this._config.variable);
            multivalueLabelConfig.updateSubscriptionOff = true; // prevent update event subscription
            multivalueLabelConfig.componentId =
                this._config.componentId + '_multivalueLabel';
            multivalueLabelConfig.productId = this._config.productId;
            multivalueLabelConfig.texts = this._config.texts;
            multivalueLabelConfig.componentType = 'LabelComponent';
            if (this._valueFormatter) {
                multivalueLabelConfig.value = this._formatter.getFormattedValue(value, this._valueFormatter);
            }
            else {
                multivalueLabelConfig.value = value;
            }
            multivalueLabelConfig.tagEvent =
                this._config.multivalueManagerSettings.labelTagEvent;
            labelComp = new BSSLabelComponent(this._entityTemplate, '#' + this._config.componentId, multivalueLabelConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
            this._createdComponents.push(labelComp);
            // save reference to label value
            this.$labelComponentValue = this._componentTemplate.find('#' + multivalueLabelConfig.componentId + ' .bss-label_value');
        }
        else if (this._isDropdownCreate) {
            if (this._stepNumber < this._mmSettings.minStepForDropdown) {
                // *** CREATE RADIO TABS ***
                this._isRadioTabsComponent = true;
                this._createRadioTabs();
            }
            else {
                // *** CREATE DROPDOWN ***
                this._isDropdownComponent = true;
                var multivalueDropdownConfig = this._toolbox.$.extend(true, {}, this._config);
                var dropdownComp = void 0;
                multivalueDropdownConfig.updateSubscriptionOff = true; // prevent update event subscription
                multivalueDropdownConfig.componentId += '_multivalueDropdown';
                multivalueDropdownConfig.componentType = 'DropdownComponent';
                multivalueDropdownConfig.tagEvent =
                    this._config.multivalueManagerSettings.dropdownTagEvent;
                dropdownComp = new BSSDropdownComponent(this._entityTemplate, '#' + this._config.componentId, multivalueDropdownConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
                this._createdComponents.push(dropdownComp);
                var multivalueDropdownLabelConfig = this._toolbox.$.extend(true, {}, this._config.multivalueManagerSettings.dropdownLabelConfig);
                var multivalueDropdowneContainerId = '#' +
                    this._config.componentId +
                    '_multivalueDropdown' +
                    '_dropdown-label-component';
                var labelComp = void 0;
                multivalueDropdownLabelConfig.level = this._config.level + 1;
                multivalueDropdownLabelConfig.updateSubscriptionOff = true; // prevent update event subscription
                multivalueDropdownLabelConfig.componentId =
                    this._config.componentId + '_multivalueDropdownLabel';
                multivalueDropdownLabelConfig.componentType = 'LabelComponent';
                multivalueDropdownLabelConfig.productId = this._config.productId;
                multivalueDropdownLabelConfig.texts = this._config.texts;
                multivalueDropdownLabelConfig.value = '';
                multivalueDropdownLabelConfig.tagEvent =
                    this._config.multivalueManagerSettings.labelTagEvent;
                labelComp = new BSSLabelComponent(this._entityTemplate, multivalueDropdowneContainerId, multivalueDropdownLabelConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
                this._createdComponents.push(labelComp);
            }
        }
        else {
            if (this._stepNumber < this._mmSettings.minStepForSlider) {
                // *** CREATE RADIO TABS ***
                this._isRadioTabsComponent = true;
                this._createRadioTabs();
            }
            else {
                // *** CREATE SLIDER ***
                this._isSliderComponent = true;
                var multivalueSliderConfig = this._toolbox.$.extend(true, {}, this._config);
                var sliderComp = void 0;
                multivalueSliderConfig.updateSubscriptionOff = true; // prevent update event subscription
                multivalueSliderConfig.componentId += '_multivalueSlider';
                multivalueSliderConfig.componentType = 'SliderComponent';
                multivalueSliderConfig.forceUsingRange = this._config.forceUsingRange;
                multivalueSliderConfig.componentTemplate =
                    this._mmSettings.sliderComponentTemplate;
                multivalueSliderConfig.tagEvent =
                    this._config.multivalueManagerSettings.sliderTagEvent;
                sliderComp = new BSSSliderComponent(this._entityTemplate, '#' + this._config.componentId, multivalueSliderConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
                this._createdComponents.push(sliderComp);
            }
        }
    };
    /**
     * @desc calculate step number and get possible slider values
     * @return {Object} valuesObj - return object with values adn stepNumber
     * @private
     */
    BSSMultivalueManagerComponent.prototype._getSliderValuesAndStepNumber = function () {
        var _a;
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _getSliderValuesAndStepNumber');
        var list;
        var listValue;
        var max;
        var min;
        var step;
        var valuesObj = { values: null, stepNumber: null, options: null };
        if (this._config.configuration) {
            this._outputObject = this._getValueObject(this._config.configuration);
            var selectedValue = this._config.resultData[this._outputObject.productId][this._outputObject.checked];
            var valuesTab = void 0;
            var optionsTab = void 0;
            var selectedIndex = void 0;
            var labelString = void 0;
            try {
                valuesTab =
                    this._config.resultData[this._outputObject.productId][this._outputObject.value].split(';');
                selectedIndex = this._toolbox._.indexOf(valuesTab, selectedValue);
                if (this._outputObject.option &&
                    this._config.resultData[this._outputObject.productId][this._outputObject.option]) {
                    optionsTab =
                        this._config.resultData[this._outputObject.productId][this._outputObject.option].split(';');
                }
                else {
                    optionsTab = valuesTab;
                }
                //if nothing is selected we should set empty string
                labelString = optionsTab[selectedIndex]
                    ? optionsTab[selectedIndex]
                    : '';
                if (this._outputObject.formatter && labelString) {
                    labelString = this._formatter.getFormattedValue(labelString, this._outputObject.formatter);
                }
            }
            catch (e) {
                labelString = '';
            }
            valuesObj.values = valuesTab;
            valuesObj.options = optionsTab;
            valuesObj.stepNumber = valuesObj.values.length;
            this._valueFormatter = this._outputObject.formatter;
        }
        else {
            if (this._config.variableList) {
                list = this._config.variableList;
            }
            if (list) {
                listValue = this._getValue(list);
            }
            if (this._config.variableMax) {
                max = +this._getValue(this._config.variableMax);
            }
            if (this._config.variableMin) {
                min = +this._getValue(this._config.variableMin);
            }
            if (this._config.variableStep) {
                step = +this._getValue(this._config.variableStep);
            }
            // 1: check variableList
            if (listValue) {
                valuesObj.values = this._validateVariableList(listValue);
                valuesObj.stepNumber = valuesObj.values.length;
            }
            // 2: check  variableMin, variableMax and variableStep
            else {
                try {
                    if ((_a = this._config) === null || _a === void 0 ? void 0 : _a.optional) {
                        return;
                    }
                    if (isNaN(max) || isNaN(min) || isNaN(step) || (step <= 0 && min !== max)) {
                        this.setErrorObject({
                            errorMsg: 'config -> there is no complete set of data',
                            errorSeverity: 'critical',
                        });
                        return valuesObj;
                    }
                    else {
                        if (step === 0 && min === max) {
                            valuesObj.stepNumber = 1;
                            step = 1;
                        }
                        else {
                            valuesObj.stepNumber = Math.ceil((max - min) / step) + 1;
                        }
                        valuesObj.values = [];
                        if (this._forceRounded && min > 0) {
                            valuesObj.values.push(min);
                            min = Math.ceil(min / step) * step;
                        }
                        for (var i = min; i <= max; i += step) {
                            valuesObj.values.push(i);
                        }
                        if (valuesObj.values[valuesObj.values.length - 1] < max) {
                            valuesObj.values.push(max);
                        }
                    }
                }
                catch (errorMsg) {
                    this.setErrorObject({
                        errorMsg: errorMsg,
                        errorSeverity: 'critical',
                    });
                    return valuesObj;
                }
            }
        }
        return valuesObj;
    };
    /**
     * @desc validate variableList - check if has proper structure and values
     * @param {String} variableList - slider list from BSSConnector
     * @return {Array} variableArray - array of values based on variableList, returns empty Array if list is not valid
     * @private
     */
    BSSMultivalueManagerComponent.prototype._validateVariableList = function (variableList) {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _validateVariableList' +
            ' | Params: ', variableList);
        var variableArray = [];
        try {
            if (!helper.validateRegExp('^-?[0-9]+([.][0-9]+)?((;-?[0-9]+)([.][0-9]+)?)*$', variableList)) {
                this.setErrorObject({
                    errorMsg: "config -> variableList or linked value doesn't match proper format",
                    errorSeverity: 'critical',
                });
            }
            else {
                var arr = variableList.split(';');
                if (arr.length > 1) {
                    arr = helper.sortAsFloats(arr);
                    if (this._isSliderListCorrect(arr)) {
                        variableArray = arr;
                    }
                }
                else {
                    variableArray = arr;
                }
            }
        }
        catch (errorMsg) {
            this.setErrorObject({
                errorMsg: errorMsg,
                errorSeverity: 'critical',
            });
        }
        return variableArray;
    };
    /**
     * @desc create radio tabs component based on config and calculations
     * @private
     */
    BSSMultivalueManagerComponent.prototype._createRadioTabs = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _createRadioTabs');
        var checkedValue;
        var dataChecked;
        var dataDisabled = this._config.disabled;
        var multivalueRadioTabsConfig;
        var tempMultivalueRadioBtnConfig;
        var multivalueRadioBtnConfigArr = [];
        var radioSwitchContainerId = '#' + this._config.componentId + '_multivalueRadioTabs_radio-btns';
        var multivalueRadioTabsLabelConfig;
        var radioTabsTitleContainerId = '#' + this._config.componentId + '_multivalueRadioTabs_title';
        var radioTabsComp;
        var labelComp;
        var lengthDecimalPlaces;
        if (this._config.variable) {
            checkedValue = this._getValueObject(this._config.variable);
            dataChecked = checkedValue.productId + '.' + checkedValue.value;
            lengthDecimalPlaces = this._getValue(this._config.variable).split('.')[1]
                ? this._getValue(this._config.variable).split('.')[1].length
                : null;
        }
        else {
            checkedValue = this._getValueObject(this._config.configuration);
            dataChecked = checkedValue.productId + '.' + checkedValue.checked;
        }
        this.$radioComponentInput = [];
        this.$radioComponentLabel = [];
        // create radio-tabs-component - a container for all radios and label
        multivalueRadioTabsConfig = this._toolbox.$.extend(true, {}, this._config);
        multivalueRadioTabsConfig.hintText = null;
        //prevent radio tabs to initTabs twice
        multivalueRadioTabsConfig.remoteInit = true;
        multivalueRadioTabsConfig.updateSubscriptionOff = true; // prevent update event subscription
        multivalueRadioTabsConfig.componentId += '_multivalueRadioTabs';
        multivalueRadioTabsConfig.componentType = 'RadioTabsComponent';
        if ('radioTabsConfig' in this._config.multivalueManagerSettings) {
            multivalueRadioTabsConfig.class =
                this._config.multivalueManagerSettings.radioTabsConfig.class || '';
            multivalueRadioTabsConfig.initOnSwiper =
                this._config.multivalueManagerSettings.radioTabsConfig.initOnSwiper ||
                    false;
        }
        /**
         * entityReady flag for the radio-tabs element (swiper) to block swiper only in first initialization,
         * on each next initialization it should not have 'pointer-event' attribute
         * @type {boolean}
         */
        multivalueRadioTabsConfig.entityReady = this.entityReady;
        radioTabsComp = new BSSRadioTabsComponent(this._entityTemplate, '#' + this._config.componentId, multivalueRadioTabsConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
        this._createdComponents.push(radioTabsComp);
        // create label for radio-tabs component
        multivalueRadioTabsLabelConfig = this._toolbox.$.extend(true, {}, this._config.multivalueManagerSettings.radioTabsConfig.labelConfig);
        multivalueRadioTabsLabelConfig.level =
            multivalueRadioTabsLabelConfig.level + 1;
        multivalueRadioTabsLabelConfig.updateSubscriptionOff = true; // prevent update event subscription
        multivalueRadioTabsLabelConfig.componentId =
            this._config.componentId + '_multivalueRadioTabsLabel';
        multivalueRadioTabsLabelConfig.componentType = 'LabelComponent';
        multivalueRadioTabsLabelConfig.productId = this._config.productId;
        multivalueRadioTabsLabelConfig.texts = this._config.texts;
        multivalueRadioTabsLabelConfig.value = '';
        multivalueRadioTabsLabelConfig.tagEvent =
            this._config.multivalueManagerSettings.radioTagEvent;
        labelComp = new BSSLabelComponent(this._entityTemplate, radioTabsTitleContainerId, multivalueRadioTabsLabelConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
        this._createdComponents.push(labelComp);
        // prepare base config for radio buttons (radio switch)
        tempMultivalueRadioBtnConfig = this._toolbox.$.extend(true, {}, this._config);
        tempMultivalueRadioBtnConfig.updateSubscriptionOff = true; // prevent update event subscription
        tempMultivalueRadioBtnConfig.configuration =
            '<value data-checked="' +
                dataChecked +
                '" data-disabled="' +
                dataDisabled +
                '"></value>';
        tempMultivalueRadioBtnConfig.groupName =
            this._config.componentId + '_multivalueRadioTabsGroup';
        tempMultivalueRadioBtnConfig.componentTemplate = 'radioSwitchTemplate';
        // create all radio button components
        for (var i = 0; i < this._stepNumber; i++) {
            multivalueRadioBtnConfigArr[i] = this._toolbox.$.extend(true, {}, tempMultivalueRadioBtnConfig);
            multivalueRadioBtnConfigArr[i].level =
                multivalueRadioBtnConfigArr[i].level + 1;
            multivalueRadioBtnConfigArr[i].componentId +=
                '_multivalueRadioTabsSwitchBtn-' + i;
            multivalueRadioBtnConfigArr[i].componentType = 'RadioButtonComponent';
            if (this._values) {
                if (lengthDecimalPlaces) {
                    multivalueRadioBtnConfigArr[i].value = parseFloat(this._values[i]).toFixed(lengthDecimalPlaces);
                }
                else {
                    multivalueRadioBtnConfigArr[i].value = this._values[i];
                }
                if (this._isDropdownCreate && this._options) {
                    if (this._valueFormatter) {
                        multivalueRadioBtnConfigArr[i].text =
                            this._formatter.getFormattedValue(this._options[i], this._valueFormatter);
                    }
                    else {
                        multivalueRadioBtnConfigArr[i].text = this._options[i];
                    }
                }
                else {
                    if (this._valueFormatter) {
                        multivalueRadioBtnConfigArr[i].text =
                            this._formatter.getFormattedValue(this._values[i], this._valueFormatter);
                    }
                    else {
                        multivalueRadioBtnConfigArr[i].text = this._values[i];
                    }
                }
            }
            multivalueRadioBtnConfigArr[i].hintText = null;
            multivalueRadioBtnConfigArr[i].tagEvent =
                this._config.multivalueManagerSettings.radioTagEvent;
            var radioBtnComp = new BSSRadioButtonComponent(this._entityTemplate, radioSwitchContainerId, multivalueRadioBtnConfigArr[i], this._eventManager, this._formatter, this._resolution, this._toolbox);
            this._createdComponents.push(radioBtnComp);
            // save reference to radio button value and text
            this.$radioComponentInput[i] = this._componentTemplate.find('#' +
                multivalueRadioBtnConfigArr[i].componentId +
                ' .bss-radio-switch_input');
            this.$radioComponentLabel[i] = this._componentTemplate.find('#' +
                multivalueRadioBtnConfigArr[i].componentId +
                ' .bss-radio-switch_label');
        }
        // get radio group for radio button components
        this._toolbox._.forEach(this._createdComponents, function (component) {
            if (component._config.componentType === 'RadioButtonComponent') {
                component._getRadioGroup();
            }
        });
        // if binded value is different than any of radio buttons values - select the one that's value is closest
        this._selectClosestRadioBtn();
        // init radio tabs component
        this._toolbox._.forEach(this._createdComponents, function (component) {
            if (component._config.componentType === 'RadioTabsComponent') {
                component._initRadioTabs();
            }
        });
    };
    /**
     * @desc when binded value is not on the values list, select radio button with closest value
     * @private
     */
    BSSMultivalueManagerComponent.prototype._selectClosestRadioBtn = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _selectClosestRadioBtn');
        var bindedValue = parseInt(this._config.resultData[this._outputProdId][this._outputValueName]);
        if (this._values.indexOf(bindedValue) < 0) {
            var closestValue = this._getClosestNumber(bindedValue, this._values);
            this._toolbox._.forEach(this.$radioComponentInput, function (radioInput) {
                if (parseInt(radioInput.val()) === closestValue) {
                    radioInput.prop('checked', true);
                    radioInput.trigger('click');
                    return false;
                }
            });
        }
    };
    /**
     * @desc update multivalue manager components - update or recreate all components
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @private
     * @override
     */
    BSSMultivalueManagerComponent.prototype.update = function (publisherName, data) {
        var _this = this;
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = data.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof data.resultData[this._config.productId[0]].error_code !==
                'undefined') {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        // update multivalue-manager config
        var newData = data.resultData[this._config.productId[this.productIterator]];
        if (!!this._config.resultDataFilterComponent &&
            typeof this._config.resultDataFilterComponent === 'object') {
            var newAditionalData = this._config.resultDataFilterComponent[this._config.productId[this.productIterator]];
            if (typeof newAditionalData === 'object') {
                Object.assign(newData, newAditionalData);
            }
        }
        this._config.resultData[this._config.productId[this.productIterator]] =
            newData;
        // *** IF LIMIT CHANGED (MIN, MAX, STEP OR LIST) ***
        if (this._isSliderLimitChanged(newData, this._sliderLimitVariables) ||
            this._isDropdownCreate) {
            // get new step number and values list
            var newValuesObj_1 = this._getSliderValuesAndStepNumber();
            if ((this._isSliderComponent &&
                newValuesObj_1.stepNumber >= this._mmSettings.minStepForSlider &&
                (this._mmSettings.minVariableRange === 0 ||
                    newValuesObj_1.values[newValuesObj_1.values.length - 1] -
                        newValuesObj_1.values[0] >=
                        this._mmSettings.minVariableRange)) ||
                (this._isDropdownComponent &&
                    newValuesObj_1.stepNumber >= this._mmSettings.minStepForDropdown)) {
                // if slider is created & and new step number is enough for slider - update slider or if dropdown is created & and new step number is enough for dropdown - update dropdown
                this._updateComponents(publisherName, data);
            }
            else if (newValuesObj_1.stepNumber === this._stepNumber) {
                // if label or radio-tabs is created & step number is the same - set new values and update all components
                if (this._isRadioTabsComponent) {
                    // update radio buttons - change values and select proper switch
                    var counter_1 = 0;
                    this._toolbox._.forEach(this._createdComponents, function (component) {
                        if (component._config.componentType === 'RadioButtonComponent') {
                            _this._values = newValuesObj_1.values;
                            _this._options = newValuesObj_1.options;
                            component.value = newValuesObj_1.values[counter_1];
                            if (_this._isDropdownCreate && _this._options) {
                                if (_this._valueFormatter) {
                                    component.text = _this._formatter.getFormattedValue(newValuesObj_1.options[counter_1], _this._valueFormatter);
                                }
                                else {
                                    component.text = newValuesObj_1.options[counter_1];
                                }
                            }
                            else {
                                component.text = _this._formatter.getFormattedValue(newValuesObj_1.values[counter_1], _this._valueFormatter);
                            }
                            _this.$radioComponentInput[counter_1].val(component.value);
                            _this.$radioComponentLabel[counter_1].html(component.text);
                            counter_1++;
                        }
                    });
                    this._updateComponents(publisherName, data);
                }
                else {
                    // update label
                    var newLabelValue = newValuesObj_1.values[0];
                    var newFormattedLabelValue = void 0;
                    var newLabelValueOption = void 0;
                    if (newValuesObj_1.options && newValuesObj_1.options[0]) {
                        newLabelValueOption = newValuesObj_1.options[0];
                        if (this._valueFormatter) {
                            newFormattedLabelValue = this._formatter.getFormattedValue(newLabelValueOption, this._valueFormatter);
                        }
                        else {
                            newFormattedLabelValue = newLabelValueOption;
                        }
                    }
                    else {
                        if (this._valueFormatter) {
                            newFormattedLabelValue = this._formatter.getFormattedValue(newLabelValue, this._valueFormatter);
                        }
                        else {
                            newFormattedLabelValue = newLabelValue;
                        }
                    }
                    this.$labelComponentValue.html(newFormattedLabelValue);
                }
            }
            else {
                // if step number changed and new component is needed - destroy all components and create new ones
                this._recreateComponents(publisherName, data);
            }
        }
        // *** IF LIMIT IS THE SAME & THERE IS RESULT DATA - UPDATE ALL COMPONENTS ***
        else if (typeof newData[this._outputValueName] !== 'undefined') {
            this._updateComponents(publisherName, data);
        }
        this._stopUpdateFlag = false;
        this._isRevertStateEvent = false;
    };
    /**
     * @desc update all created components
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @private
     */
    BSSMultivalueManagerComponent.prototype._updateComponents = function (publisherName, data) {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _updateComponents' +
            ' | Params: ', publisherName, data);
        this._toolbox._.forEach(this._createdComponents, function (component) {
            component.update(publisherName, data);
        });
        if (this._isRadioTabsComponent) {
            // if binded value is different than any of radio buttons values - select the one that's value is closest
            this._selectClosestRadioBtn();
        }
    };
    /**
     * @desc destroy all created components and create new ones
     * @private
     */
    BSSMultivalueManagerComponent.prototype._recreateComponents = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _recreateComponents');
        this.entityReady = true;
        this._destroyComponents();
        this._prepareData();
        this._createProperComponent();
    };
    /**
     * @desc destroys all created components
     * @private
     */
    BSSMultivalueManagerComponent.prototype._destroyComponents = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : _destroyComponents');
        // sort components by level - only if more than 1
        var componentsByLevel = this._createdComponents;
        if (componentsByLevel.length > 1) {
            componentsByLevel = this._toolbox._.orderBy(this._createdComponents, function (elm) {
                return elm._config.level;
            });
            componentsByLevel = this._toolbox._.reverse(componentsByLevel);
        }
        // destroy all created component - the oreder is important
        for (var i = 0; i < componentsByLevel.length; i++) {
            componentsByLevel[i].destroy();
        }
        // clear data
        this._createdComponents = [];
        this.$labelComponentValue = null;
        this._isRadioTabsComponent = false;
        this._isSliderComponent = false;
        this._isDropdownComponent = false;
    };
    /**
     * @desc destroys multivalue manager component and all his component and call super method
     * @public
     * @override
     */
    BSSMultivalueManagerComponent.prototype.destroy = function () {
        logger.info('MultivalueManagerComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        this._destroyComponents();
        _super.prototype.destroy.call(this);
    };
    /**
     * @desc initialize tagging - tagEvent array should be passed to each component, and each component should call its own _initializeTagging
     * @private
     * @override
     */
    BSSMultivalueManagerComponent.prototype._initializeTagging = function () { };
    return BSSMultivalueManagerComponent;
}(BSSAbstractComponent));
export default BSSMultivalueManagerComponent;
